module.exports = __webpack_public_path__ + "static/media/elDesafio.08983847.webp";